import PersistedStorage from '../../lib/PersistedStorage';

const InvoiceStorage = PersistedStorage('[Cart] Invoice_Id');

export {
  InvoiceStorage,
};


// WEBPACK FOOTER //
// ./src/screens/Cart/helpers.js